import Icon from "components/AppIcon";
import Button from "components/ui/Button";
import React from "react";

export default function ViewProductModal({ product, onClose, editBatch, deleteBatch, haspermission }) {
    const batches = product.batches
    const [downloadingBatchId, setDownloadingBatchId] = React.useState(null)
    const [deletingBatchId, setDeletingBatchId] = React.useState(null)

    const handleDownloadbatch = async (batchId) => {
        if (downloadingBatchId) return;
        // console.log("i am called")
        if (!batchId) {
            alert('Please enter batch ID');
            return;
        }
        setDownloadingBatchId(batchId);
        const token = localStorage.getItem('token');
        const url = import.meta.env.VITE_APP_ADMINURL + `/api/download-batch-excel?batchId=${batchId}&columns=1&repeats=1`;
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
            if (!response.ok) {
                throw new Error('failed to download File')
            }
            const blob = await response.blob()
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = 'batch_export.xlsx';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(downloadUrl)
        } catch (error) {
            console.error(error);
            alert('Error downloading file')
        } finally {
            setDownloadingBatchId(null);
        }
    };

    const handleDeleteBatch = async (batch) => {
        if (deletingBatchId) return;
        try {
            setDeletingBatchId(batch.id);
            await deleteBatch(batch);
        } finally {
            setDeletingBatchId(null);
        }
    }
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4">
                {/* Header */}
                <div className="flex items-center justify-between p-6 border-b border-gray-200">
                    <h2 className="text-xl font-semibold text-text-primary">{product.title}</h2>
                    <button
                        onClick={onClose}
                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                    >
                        <Icon name="X" size={20} color="#6b7280" />
                    </button>
                </div>
                <div className="space-y-4">
                    {batches.length === 0 ? (
                        <p className="text-text-secondary text-center p-12">No batches found for this product.</p>
                    ) : (
                        <div className="divide-y divide-border max-h-[75vh] scroll overflow-y-auto">
                            {batches.map((batch) => {
                                const isDownloading = downloadingBatchId === batch.id;
                                return (
                                    // <div key={batch.id} className="grid lg:grid-cols-[3fr_1fr] grid-cols-[1fr]">
                                    <div key={batch.id} className="grid lg:grid-cols-[3fr_1fr] grid-cols-[1fr]">
                                        <div className="p-4 lg:p-6 gap-2 flex flex-col">
                                            <p><strong>Batch ID:</strong> {batch.id}</p>
                                            <p className="truncate"><strong>Batch title:</strong> {batch.title}</p>
                                            <p><strong>Batch Code:</strong> {batch.batch_code}</p>
                                            <p><strong>Total Count:</strong> {batch._count.qr_codes}</p>
                                        </div>
                                        <div className="pb-4 lg:p-6 flex gap-4 items-center justify-center flex-wrap">
                                            {haspermission('Create Product') &&
                                                (<>
                                                    <Button
                                                        iconName="Edit"
                                                        className="text-primary border border-primary bg-white"
                                                        onClick={() => { editBatch(batch) }}
                                                    />
                                                    <Button
                                                        iconName="Trash2"
                                                        className="border text-red-500 border-red-500 bg-white"
                                                        loading={deletingBatchId === batch.id}
                                                        onClick={() => { handleDeleteBatch(batch) }}
                                                    />
                                                </>
                                                )
                                            }
                                            {haspermission('Export Data') &&
                                                <Button
                                                iconName={
                                                    !batch?.isBatchCreated
                                                        ? "Loader"
                                                        : isDownloading
                                                        ? ""
                                                        : "Download"
                                                }
                                                className={`text-nowrap text-white  ${
                                                    batch?.isBatchCreated ? "" : "bg-orange-600"
                                                }`}
                                                disabled={!batch?.isBatchCreated || isDownloading}
                                                onClick={() => handleDownloadbatch(batch.id)}
                                            >
                                                {!batch?.isBatchCreated
                                                    ? "In Process"
                                                    : isDownloading
                                                    ? "Downloading..."
                                                    : "Download"}
                                            </Button>
                                            }
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
